/* eslint-disable */
//Req
import "jquery";
import Slick from "../components/slick";
import Mixitup from "../components/mixitup";
import Xpandy from "../components/xpandy";
import animateValues from '../components/animateValues';

export default {
    init() {
        //Functions

        // function isElementInViewport(el) {
        //     var rect = el.getBoundingClientRect();
        //     return (
        //         rect.top >= 0 &&
        //         rect.left >= 0 &&
        //         rect.bottom <=
        //             (window.innerHeight ||
        //                 document.documentElement.clientHeight) &&
        //         rect.right <=
        //             (window.innerWidth || document.documentElement.clientWidth)
        //     );
        // }

        // function debounce(func, wait, immediate) {
        //     var timeout;
        //     return function() {
        //         var context = this,
        //             args = arguments;
        //         var later = function() {
        //             timeout = null;
        //             if (!immediate) func.apply(context, args);
        //         };
        //         var callNow = immediate && !timeout;
        //         clearTimeout(timeout);
        //         timeout = setTimeout(later, wait);
        //         if (callNow) func.apply(context, args);
        //     };
        // }
        var device;
        $(document).ready(function() {
            if ($("header").width() <= 1060) {
                device = "mobile";
            } else {
                device = "desktop";
            }
        });

        $(window).resize(function() {
            if ($("header").width() <= 1060) {
                device = "mobile";
            } else {
                device = "desktop";
            }
        });
        if ($(".Portfolio").length) {
            $('#Funds option[value="all"]').attr("selected", true);
            $('#Industries option[value="all"]').attr("selected", true);
            $('#Status option[value="all"]').attr("selected", true);
        }

        setTimeout(function() {
            $(window).resize();
        }, 500);

        $(".InvestmentSlider-slides").slick({
            draggable: false,
            arrows: false,
            fade: true,
            asNavFor: ".InvestmentSlider-nav",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        draggable: true,
                        fade: false
                    }
                }
            ]
        });

        $(".InvestmentSlider-nav").slick({
            draggable: false,
            arrows: false,
            asNavFor: ".InvestmentSlider-slides",
            slidesToShow: 4,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1060,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true,
                        centerMode: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        slidesToScroll: 1,
                        slidesToShow: 1
                    }
                }
            ]
        });

        //Home Slider

        // $(".Hero-cards").slick({
        //     dots: true,
        //     infinite: true,
        //     slidesToShow: 2,
        //     slidesToScroll: 1,
        //     autoplay: true,
        //     autoplaySpeed: 4000,
        //     responsive: [
        //         {
        //             breakpoint: 1024,
        //             ssettings: {
        //                 slidesToShow: 2,
        //                 slidesToScroll: 1
        //             }
        //         },
        //         {
        //             breakpoint: 600,
        //             settings: {
        //                 slidesToShow: 1,
        //                 slidesToScroll: 1
        //             }
        //         },
        //         {
        //             breakpoint: 480,
        //             settings: {
        //                 slidesToShow: 1,
        //                 slidesToScroll: 1
        //             }
        //         }
        //         // You can unslick at a given breakpoint now by adding:
        //         // settings: "unslick"
        //         // instead of a settings object
        //     ]
        // });

        //Hero Counter

        

        const numberElements = document.querySelectorAll('.NumberCards--valueToCount');
Array.from(numberElements).forEach(el => (el.innerText = 0));

if (window.IntersectionObserver) {
  let observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // ✅ Once the first element is visible, unobserve everything
          numberElements.forEach(section => observer.unobserve(section));

          // ✅ Fire animations for ALL number elements at once
          numberElements.forEach(el => {
            var valueCheck = el.dataset.value;
            if (valueCheck.indexOf(".") === -1) {
              animateValues({ a: 0 }, 2500, {
                a: parseFloat(el.dataset.value),
                onUpdate: v =>
                  (el.innerText = v.a.toFixed(0).replace(/\.0+$/, '')),
                ease: t =>
                  t < 0.5
                    ? 16 * t * t * t * t * t
                    : 1 + 16 * --t * t * t * t * t
              });
            } else {
              animateValues({ a: 0 }, 2500, {
                a: parseFloat(el.dataset.value),
                onUpdate: v =>
                  (el.innerText = v.a.toFixed(1).replace(/\.0+$/, '')),
                ease: t =>
                  t < 0.5
                    ? 16 * t * t * t * t * t
                    : 1 + 16 * --t * t * t * t * t
              });
            }
          });
        }
      });
    },
    { rootMargin: '0px 0px -200px 0px' }
  );

  numberElements.forEach(section => observer.observe(section));
}


        //Call Out Slider

        $(".Callouts .row").slick({
            dots: true,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1024,
                    ssettings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });

        //MixItUp
        console.log('check');
        if ($(".Portfolio").length) {
            $("#Funds").on("change", function() {
                var filter = $(this).val();
                $(".Portfolio-items .funds").removeClass("is-active");
                $(".Portfolio-items .funds").addClass("is-inactive");
                if (filter == "all") {
                    $(".Portfolio-items .funds").addClass("is-active");
                    $(".Portfolio-items .funds").removeClass("is-inactive");
                    if (device == "desktop") {
                        $(".Portfolio-items .funds:nth-child(n+3)").addClass(
                            "previous"
                        );
                    } else if ((device = "mobile")) {
                        $(".funds.is-active").removeClass("is-open");
                        $(".funds.is-active")
                            .first()
                            .addClass("is-open");
                    }

                    $(".Portfolio-loader").show();
                } else {
                    $(filter).addClass("is-active");
                    $(filter).removeClass("is-inactive");
                    $(filter).removeClass("previous");
                    $(".Portfolio-loader").hide();
                }
            });
            if ((device = "mobile")) {
                $(".funds").removeClass("is-open");
                $(".funds")
                    .first()
                    .addClass("is-open");
            }
            setTimeout(function() {
                var mixer = Mixitup(".Portfolio-items", {
                    selectors: {
                        target: ".mix"
                    },
                    animation: {
                        duration: 200
                    }
                });

                function applyCombinedFilters() {
                    var statusVal = $("#Status").val();
                    var industryVal = $("#Industries").val();

                    // Default to "all" if either dropdown is set to "all"
                    // MixItUp expects selectors like '.class1.class2' for AND logic
                    var filter = '';

                    if (statusVal === 'all' && industryVal === 'all') {
                        filter = 'all';
                    } else if (statusVal !== 'all' && industryVal !== 'all') {
                        filter = statusVal + industryVal; // AND logic
                    } else if (statusVal !== 'all') {
                        filter = statusVal;
                    } else if (industryVal !== 'all') {
                        filter = industryVal;
                    }

                    $(".Portfolio-items .previous").removeClass("previous");
                    mixer.filter(filter);
                    $(".Portfolio-loader").hide();
                    $(".funds").removeClass("is-empty");

                    setTimeout(function () {
                        $(".funds").each(function () {
                            var $count = $(this).children(".mix:visible").length;
                            if ($count == 0) {
                                $(this).addClass("is-empty");
                            }
                        });
                    }, 500);
                }

                // Bind both selects to the same function
                $("#Status, #Industries").on("change", applyCombinedFilters);




                // let defaultValues = [".Catalog-genres", ".how-to"];

                // defaultValues.forEach(
                //     val =>
                //         document.querySelector(val) ? mixer.filter(val) : false
                // );
            }, 500);

            $(".Portfolio-loader").on("click", function() {
                if ($(".previous").length) {
                    $(".Portfolio-items .previous")
                        .first()
                        .removeClass("previous");
                    if ($(".previous").length == 0) {
                        $(this).hide();
                    }
                } else {
                    $(this).hide();
                }
            });
            setTimeout(function() {
                if (device == "desktop") {
                    $(".Portfolio-items .funds:nth-child(n+3)").addClass(
                        "previous"
                    );
                }
            }, 500);
        }

        //Hamburger
        $(".hamburger").click(function() {
            $(this).toggleClass("is-active");
            $(".HeaderExpand").toggleClass("is-active");
            $("html, body").toggleClass("is-locked");
            $(".HeaderMobile").toggleClass("is-active");
        });

        //Tabs
        $(".Tabbed a").click(function() {
            $(".Tabbed a").removeClass("Tabbed-item--is-active");
            $(this).addClass("Tabbed-item--is-active");
            var $target = $(this).data("tab");
            if ($target == "locations") {
                $(".MapSlider").removeClass("MapSlider--is-inactive");
                $(".MapSlider").addClass("MapSlider--is-active");
                $(".TableList").addClass("TableList--is-inactive");
                $(".TableList").removeClass("TableList--is-active");
            } else if ($target == "overview") {
                $(".MapSlider").addClass("MapSlider--is-inactive");
                $(".MapSlider").removeClass("MapSlider--is-active");
                $(".TableList").removeClass("TableList--is-inactive");
                $(".TableList").addClass("TableList--is-active");
            }
            $(".InvestmentSlider-nav")
                .slick("getSlick")
                .refresh();
            $(".InvestmentSlider-slides")
                .slick("getSlick")
                .refresh();
        });

        //Mobile menu expand list
        $(".HeaderMobile .menu-item-has-children > a").click(function(e) {
            e.preventDefault();
            var $menu = $(this).siblings(".sub-menu");
            $(this).toggleClass("is-active");
            $menu.toggleClass("is-active");
        });

        $(".Portfolio-expand").click(function(e) {
            e.preventDefault();
            if (device == "mobile") {
                $(this)
                    .closest(".funds")
                    .toggleClass("is-open");
            }
        });

        //scroll check

        $(window).scroll(function() {
            if ($("body.home").length) {
                if ($(document).scrollTop() > 100) {
                    $(".Header").removeClass("Header--home");
                } else {
                    $(".Header").addClass("Header--home");
                }
            }
        });

        //
    },
    finalize() {
        //

        //Xpandy
        var Team = new Xpandy(".Xpandy", { items: ".Xpandy-feed-item" });

        if (window.location.hash) {
            var memberSlug = window.location.hash.substr(1);
            var member = document.querySelector("." + memberSlug);
            Team[0].togglePreview(member);
            member.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }

        $(window).scroll();
        $(window).resize();
    }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js